module.exports = __webpack_public_path__ + "img/contrato-rastreabilidade.dc2923e1.svg";